import e from "react";
import { mintelRed200 as o, mintelRed400 as n } from "mintel-tokens";
import { I as s } from "./Icon-BuIPTPJn.es.js";
import { T as a } from "./index-Dd-4N6BE.es.js";
import { u as l } from "./DarkModeProvider-xoZXm3ct.es.js";
import './InputError.css';const p = "16px", _ = "InputError-module__inputError___514Yl", u = "InputError-module__icon___6PjqM", d = "InputError-module__text___psfr4", r = {
  iconSize: p,
  inputError: _,
  icon: u,
  text: d
}, z = ({
  id: i,
  children: c,
  dark: m
}) => {
  const t = l(m);
  return /* @__PURE__ */ e.createElement("div", { className: r.inputError }, /* @__PURE__ */ e.createElement("div", { className: r.icon }, /* @__PURE__ */ e.createElement(
    s,
    {
      name: "warning",
      color: t ? o : n,
      size: r.iconSize
    }
  )), /* @__PURE__ */ e.createElement("div", { className: r.text }, /* @__PURE__ */ e.createElement(
    a.Body3,
    {
      id: i,
      color: t ? o : n,
      responsive: !0
    },
    c
  )));
};
export {
  z as I
};
